"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateTypes = void 0;
/**
 * Template types.
 *
 * The values must match the configuration machine name in the backend.
 */
var TemplateTypes;
(function (TemplateTypes) {
    // Valuation creator widget.
    TemplateTypes["SEARCH_VEHICLE_VRN_ONLY"] = "template.step.search_vehicle.vrn_only";
    TemplateTypes["SEARCH_VEHICLE_VRN_AND_DETAILS"] = "template.step.search_vehicle.vrn_and_details";
    TemplateTypes["CUSTOMER"] = "template.step.customer";
    TemplateTypes["SELECT_VEHICLE"] = "template.step.select_vehicle";
    TemplateTypes["CAR_CONDITION_STEP"] = "template.step.car_condition";
    TemplateTypes["VALUATION_NEXT"] = "template.step.valuation_next";
    TemplateTypes["VALUATION"] = "template.step.valuation";
    TemplateTypes["EXCEPTION_STEP"] = "template.step.exception";
    TemplateTypes["RESTRICTED_VALUATION_STEP"] = "template.step.too_many_val";
    // Valuation view widget.
    TemplateTypes["VALUATION_VIEW"] = "template.step.valuation_view";
    // Common.
    TemplateTypes["QUESTIONNAIRE_COMPONENT"] = "template.component.qestr";
    TemplateTypes["DATE_COMPONENT"] = "template.component.date";
    TemplateTypes["ERROR"] = "template.step.error";
})(TemplateTypes = exports.TemplateTypes || (exports.TemplateTypes = {}));
